var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 12.6667C10.1295 12.6667 12.6666 10.1296 12.6666 6.99999C12.6666 3.87039 10.1295 1.33333 6.99992 1.33333C3.87032 1.33333 1.33325 3.87039 1.33325 6.99999C1.33325 10.1296 3.87032 12.6667 6.99992 12.6667Z",
    fill: "black",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99992 0.333344C3.31803 0.333344 0.333252 3.31813 0.333252 7.00001C0.333252 10.6819 3.31803 13.6667 6.99992 13.6667C8.48014 13.6667 9.84769 13.1843 10.9539 12.3681L13.1953 14.6094C13.5858 15 14.219 15 14.6095 14.6094C15 14.2189 15 13.5858 14.6095 13.1952L12.3681 10.9538C13.1842 9.84763 13.6666 8.48015 13.6666 7.00001C13.6666 3.31813 10.6818 0.333344 6.99992 0.333344ZM2.33325 7.00001C2.33325 4.4227 4.4226 2.33334 6.99992 2.33334C9.57723 2.33334 11.6666 4.4227 11.6666 7.00001C11.6666 9.57732 9.57723 11.6667 6.99992 11.6667C4.4226 11.6667 2.33325 9.57732 2.33325 7.00001Z",
    fill: "black",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4074 4.07393C5.06984 3.41148 5.98788 3 7.0001 3C8.01235 3 8.93039 3.41148 9.59284 4.07393C9.98337 4.46445 9.98337 5.09762 9.59284 5.48814C9.20232 5.87866 8.56915 5.87866 8.17863 5.48814C7.87594 5.18545 7.46065 5 7.0001 5C6.53959 5 6.1243 5.18545 5.82161 5.48814C5.43108 5.87866 4.79792 5.87866 4.4074 5.48814C4.01687 5.09762 4.01687 4.46445 4.4074 4.07393Z",
    fill: "black",
    fillOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLight);
export default __webpack_public_path__ + "static/media/search_light.f44530a85d5941a18cec5614396327a0.svg";
export { ForwardRef as ReactComponent };